<button 
    (click)="onClick$.emit(data)"
    class="area"
>
    <div class="column left">
        <p-checkbox
            (ngModelChange)="onModelChange($event)"
            [ngModel]="checked"
            [binary]="true"
            inputId="binary"
        ></p-checkbox>
    </div>
    <div (click)="onClickName$.emit(data)" class="column right">
        <img class="area__icon" [src]="data.Tp | areaTypeImg" alt="icon">
        <div class="area__details">
            <h2>
                {{ data.Nm }}
            </h2>
            <!-- <span *ngIf="data.address">
                {{ data.address }}
            </span> -->
        </div>
    </div>
    <div class="area__actions">
        <button 
            (click)="onEdit$.emit(data)"
            class="edit"
            [pTooltip]="'areas.edit' | translate"
            tooltipPosition="top"
        >
            <i class="icon pi pi-pencil"></i>
        </button>
        <button 
            (click)="onDelete$.emit(data)"
            class="delete"
            [pTooltip]="'areas.delete' | translate"
            tooltipPosition="top"
        >
            <i class="icon pi pi-trash"></i>
        </button>
    </div>
</button>
